import script from "./inventoryTransferDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./inventoryTransferDetail.vue?vue&type=script&setup=true&lang=js"

import "./inventoryTransferDetail.vue?vue&type=style&index=0&id=76919162&lang=less"

const __exports__ = script;

export default __exports__